<template>
  <v-combobox
    v-model="ths_data"
    :items="timeOptions"
    :label="label"
    prepend-icon="mdi-clock-time-four-outline"
    class="pickup-time-picker pt-0"
    clearable
    hide-no-data
    :menu-props="{ maxHeight: 300 }"
    :error-messages="inputErrors"
    :disabled="disabled"
    @keypress="allowTimeCharacters"
    @input.native="sanitizeInput"
    @change="commit(ths_data)"
    @blur="commit(ths_data)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    error_messages: {
      type: [String, Array],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    startTime: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    const value = this.value == null ? '' : String(this.value);
    return {
      ths_data: value,
      lastEmittedValue: value,
      invalidTime: false,
      invalidCharacters: false,
    };
  },
  computed: {
    timeOptions() {
      const match = String(this.startTime || '').match(/^(\d{1,2}):(\d{2})$/);
      const hour = match ? Number(match[1]) : 8;
      const minute = match ? Number(match[2]) : 0;
      const startMinutes =
        hour <= 23 && minute <= 59 ? hour * 60 + minute : 8 * 60;

      return Array.from({ length: 48 }, (_, index) => {
        const totalMinutes = (startMinutes + index * 30) % (24 * 60);
        return `${String(Math.floor(totalMinutes / 60)).padStart(
          2,
          '0'
        )}:${String(totalMinutes % 60).padStart(2, '0')}`;
      });
    },
    inputErrors() {
      if (this.invalidCharacters) {
        return 'กรุณาระบุเฉพาะตัวเลขและเครื่องหมาย :';
      }
      if (this.invalidTime) return 'กรุณาระบุเวลาในรูปแบบ HH:mm';
      return this.error_messages;
    },
  },
  watch: {
    value(newValue) {
      const value = newValue == null ? '' : String(newValue);
      this.ths_data = value;
      this.lastEmittedValue = value;
      this.invalidTime = false;
      this.invalidCharacters = false;
    },
  },
  methods: {
    allowTimeCharacters(event) {
      if (event.key.length === 1 && !/[0-9:]/.test(event.key)) {
        event.preventDefault();
        this.invalidCharacters = true;
      }
    },
    sanitizeInput(event) {
      const value = event.target.value;
      const sanitized = value.replace(/[^0-9:]/g, '');
      if (sanitized === value) return;

      event.target.value = sanitized;
      this.ths_data = sanitized;
      this.invalidCharacters = true;
    },
    commit(value) {
      const text = value == null ? '' : String(value).trim();
      if (text === '') {
        this.invalidCharacters = false;
        this.invalidTime = false;
        this.emitChange('');
        return;
      }

      const match = text.match(/^(\d{1,2}):(\d{2})$/);
      const hour = match ? Number(match[1]) : -1;
      const minute = match ? Number(match[2]) : -1;
      if (!match || hour > 23 || minute > 59) {
        this.invalidCharacters = false;
        this.invalidTime = true;
        return;
      }

      const normalized = `${String(hour).padStart(2, '0')}:${String(
        minute
      ).padStart(2, '0')}`;
      this.invalidCharacters = false;
      this.invalidTime = false;
      this.ths_data = normalized;
      this.emitChange(normalized);
    },
    emitChange(value) {
      if (value === this.lastEmittedValue) return;
      this.lastEmittedValue = value;
      this.$emit('onChange', value);
    },
  },
};
</script>

<style scoped>
.pickup-time-picker {
  flex: 0 0 145px;
  max-width: 145px;
  margin-left: 4px;
}
</style>
